@if (initialized) {
  @if (step === 'customer') {
    <app-select-customer
      [emitAfterCreated]="false"
      [reloadAfterCreated]="true"
      [historyBack]="false"
      (back)="onCustomerBack()"
      (selected)="onCustomerSelected($event)"
    ></app-select-customer>
  }
  @if (step === 'contact' && model.customer) {
    <app-select-invoice-contact
      [customer]="model.customer"
      (selected)="onContactSelected($event)"
      (back)="onContactBack()"
    ></app-select-invoice-contact>
  }
  @if (step === 'trial-phonenumber') {
    <app-order-trial-phonenumber
      (selected)="onTrialPhonenumberSelected($event)"
      (backEmitter)="onTrialPhonenumberBack()"
      [historyBack]="false"
    ></app-order-trial-phonenumber>
  }
  @if (step === 'instance') {
    <app-select-instance-name
      (selected)="onInstanceNameSelected($event)"
      (backEmitter)="onSelectInstanceNameBack()"
      [isTrial]="true"
      selectedDomain=""
    ></app-select-instance-name>
  }
  @if (step === 'phonenumber') {
    <app-phonenumber
      [hideBackButton]="true"
      (selected)="onPhonenumberSelected($event)"
    ></app-phonenumber>
  }
  @if (step === 'thank-you') {
    <app-cloud-thankyou
      [orderName]="model.saleOrder?.name"
    ></app-cloud-thankyou>
  }
}
